const {batchIdToProductId} = require('./product-batch-util')

const getBatchesMatchingProductId = (productId, batches) =>
  Object.keys(batches)
    .filter(batchId => productId === batchIdToProductId(batchId))

module.exports = getBatchesMatchingProductId
